import XLSX from 'xlsx'

export default {
  data() {
    return {
      //搜索主题名字
      discussName: '',
      //添加新主题的弹窗
      dialogTableVisible: false,
      //主题讨论数组
      discussData: [],
      //修改主题讨论弹窗
      dialogdiscuss: false,
      //修改主题对象
      discussObj: {
        //主题名字
        name: '',
        //主题内容
        content: '',
        //修改资源的id
        resource_id: '',
        //修改主题表的id
        id: '',
      },
      //新增主题对象
      insertDiscussObj: {
        //主题名字
        name: '',
        //主题内容
        content: '',
      },
      //每页请求的数目
      discussLength: 15,
      //主题讨论的总数目
      discussTotal: 0,
      //偏移量
      discussOffset: 0,
      currentPage: 1,
      offset: 15,
      // 下载模板
      download: this.baseUrl + 'excel/batch_template.xlsx'
    }
  },
  methods: {
    //根据主题名字搜索主题讨论
    onSearch() {
      // // console.log(this.discussName)
      let data = { token: this.$store.state.authority_management, name: this.discussName, offset: 0, length: this.discussLength, type: 6 };
      // 这里调用搜索资源接口
      this.$post('resources/shop_search', data).then(res => {
        this.discussData = res.data.result.data
        this.discussTotal = res.data.result.total
		this.currentPage = 1
        // // console.log(this.discussData)
      })
    },
    //主题讨论编辑  
    hendelUpdate(obj) {
      this.dialogdiscuss = true
      let data = {
        token: this.$store.state.authority_management,
        resource_id: obj.id
      }
      this.$post('discuss_theme/get_with_comment', data).then(res => {
        // // console.log(res.data.result);
        this.discussObj.name = res.data.result.title;
        this.discussObj.content = res.data.result.content;
        this.discussObj.resource_id = obj.id;
        this.discussObj.id = res.data.result.id;
      })

    },
    //主题讨论删除
    hendelDelete(obj) {
      let data = {
        id: obj.id,
        token: this.$store.state.authority_management
      }
      //把资源的主题先删了
      this.$post('resources/delete', data).then(res => {
        if (res.data.status == 'success') {
          let data = {
            resource_id: obj.id,
            token: this.$store.state.authority_management
          }
          //若资源主题删除成功，再把主题表的主题也删除了
          this.$post('discuss_theme/delete', data).then(res => {
            if (res.data.status == 'success') {
              this.$message({
                message: '删除成功！',
                type: 'success',
              });
              //删除后重新请求数据
              this.getDiscussData();
            } else {
              this.$message({
                message: '删除失败！',
                type: 'error',
              })
            }

          })
        }
      })
    },
    //确定修改主题
    confirmUpdateDiscuss() {
      //请求修改资源的数据
      let data = {
        token: this.$store.state.authority_management,
        type: '6',
        name: this.discussObj.name,
        data: this.discussObj.name,
        id: this.discussObj.resource_id
      }
      //请求修改主题表的数据
      let dataTwo = {
        token: this.$store.state.authority_management,
        title: this.discussObj.name,
        content: this.discussObj.content,
        id: this.discussObj.id
      }
      //发起修改主题资源的请求
      this.$post('resources/shop_edit', data).then(res => {
        if (res.data.status == 'success') {
          return true;
        } else {
          return false;
        }
      }).then(bool => {
        if (bool) {
          //发起修改主题表的请求
          this.$post('discuss_theme/edit', dataTwo).then(res => {
            if (res.data.status == 'success') {
              this.$message({
                message: '主题修改成功！',
                type: 'success'
              })
              //关闭弹框
              this.dialogdiscuss = false;
              //重新请求数据更新
              this.getDiscussData();
            } else {
              this.$message({
                message: '主题修改失败！',
                type: 'error'
              })
            }
          })
        }
      })
    },
    //确定新增主题
    confirmUpdateInsertDiscuss() {
      let data = {
        token: this.$store.state.authority_management,
        name: this.insertDiscussObj.name,
        type: '6',
        title: this.insertDiscussObj.name,
        content: this.insertDiscussObj.content,
        data: this.insertDiscussObj.name,
        shop_id: this.$store.state.store.id
      }
      this.$post('resources/create_discuss', data).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            message: '添加主题成功！',
            type: 'success'
          })
          this.getDiscussData();
          this.dialogTableVisible = false;
          this.insertDiscussObj = {
            name: '',
            content: '',
          }
        }
      })
    },
    //当请求的页数改变的时候触发
    handleSizeChange(val) {
      this.discussLength = val;
      this.getDiscussData();

    },
    //点击分页时候
    handelCurrentPage(val) {
      this.currentPage = val;
      this.offset = (val - 1) * this.discussLength;
      if (this.discussName) {
        let data = { token: this.$store.state.authority_management, name: this.discussName, offset: this.offset, length: this.discussLength, type: 6 };
        // 这里调用搜索资源接口
        this.$post('resources/shop_search', data).then(res => {
          this.discussData = res.data.result.data
          this.discussTotal = res.data.result.total
          // // console.log(this.discussData)
        })
      }
      else {
        let data = {
          token: this.$store.state.authority_management,
          name: this.discussName,
          offset: this.offset,
          length: this.discussLength,
          type: 6
        };
        this.$post('resources/shop_search', data).then(res => {
          this.discussData = res.data.result.data;

          // // console.log(this.discussData)

          this.discussTotal = res.data.result.total
          console.table(res.data.result.data);
        })
      }

    },
    //获取所有主题讨论
    getDiscussData() {
      // let data = {
      //     token: this.$store.state.id,
      //     title: this.discussName,
      //     offset: this.discussOffset,
      //     length: this.discussLength
      // }

      // let data = {
      //     token: this.$store.state.id,
      //     name: '',
      //     offset: 15,
      //     length: this.discussLength,
      //     type: 6
      // }
      let data = {
        token: this.$store.state.authority_management,
        name: this.discussName,
        offset: this.discussOffset,
        length: this.discussLength,
        type: 6
      };
      this.$post('resources/shop_search', data).then(res => {
        this.discussData = res.data.result.data;

        // // console.log(this.discussData)

        this.discussTotal = res.data.result.total
        console.table(res.data.result.data);
      })
    },

    // 批量上传讨论主题
    upload(file, fileList) {
      let files = { 0: file.raw }
      this.readExcel(files);
    },

    // 读取表格
    readExcel(files) {
      var that = this;
      if (files.length <= 0) {//如果没有文件名
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$Message.error('上传格式不正确，请上传xls或者xlsx格式');
        return false;
      }

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const wsname = workbook.SheetNames[0];//取第一张表

          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容
          this.insert(ws)

          // that.peopleArr = [];//清空接收数据
          // if(that.peopleArr.length == 1 && that.peopleArr[0].roleName == "" && that.peopleArr[0].enLine == ""){
          //     that.peopleArr = [];
          // }
          //重写数据
          // try {

          // } catch (err) {
          //   console.log(err)
          // }

          this.$refs.upload.value = '';

        } catch (e) {
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
    },

    // 发送请求插入讨论主题数据
    insert(list) {
      list.map(item => {
        this.$post('resources/create_discuss', {
          token: this.$store.state.authority_management,
          shop_id: this.$store.state.store.id,
          name: item.title,
          data: item.content,
          title: item.title,
          content: item.content,
          type: 6
        }).then(res => {
          this.$message({
            message: '添加主题成功！',
            type: 'success'
          })
        })
      })
    }
  },
  created() {
    this.getDiscussData();
  }
}

